import { cartObject } from '../fragments/cart';
import { userErrorsObject } from '../fragments/userErrors';

const cartCreate = /* GraphQL */ `
  mutation ($input: CartInput!) {
    cartCreate(input: $input) {
      ${userErrorsObject}
      ${cartObject}
    }
  }
`;

const cartLinesRemove = /* GraphQL */ `
  mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      ${userErrorsObject}
      ${cartObject}
    }
  }
`;

const cartLinesAdd = /* GraphQL */ `
  mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      ${userErrorsObject}
      ${cartObject}
    }
  }
`;

export { cartCreate, cartLinesRemove, cartLinesAdd };
